import axios from "axios";
import router from "../router";
import store from "../store";
const baseDomain = "./api";

const baseUrl = `${window.location.origin}/api`;

const instance = axios.create({
  baseURL: baseUrl,
});
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const { status } = error.response;
    if (status === 401) {
      store.commit("setSnack", {
        message: "Ошибка авторизации",
        color: "error",
      });
      router.push({ path: "/login" });
    } else {
      store.commit("setSnack", {
        message: "Критическая ошибка",
        color: "error",
      });
    }
    return Promise.reject(error);
  }
);

export default instance;
